<template>
  <!-- the client registers in one short step and lands in the cabinet (the old 4-step questionnaire with a psychologist and a slot is gone) -->
  <v-col md="8" offset-md="2">
    <v-card class="pb-3 patient-reg">
      <p class="patient-reg__title">{{ $vuetify.lang.t("$vuetify.main.patientReg.title") }}</p>
      <stepOne></stepOne>
      <div class="patient-reg__terms">
        <v-checkbox v-model="consent" hide-details class="mt-0 pt-0">
          <template v-slot:label>
            <span>
              Погоджуюсь з
              <Terms>{{ $vuetify.lang.t("$vuetify.main.patientReg.agreeTerms") }}</Terms>
              {{ $vuetify.lang.t("$vuetify.main.patientReg.agreeAnd") }}
              <PersonalData>{{ $vuetify.lang.t("$vuetify.main.patientReg.agreePolicy") }}</PersonalData>
              та на обробку персональних даних
            </span>
          </template>
        </v-checkbox>
      </div>
      <div class="d-flex justify-end px-4">
        <v-btn color="primary" depressed large :loading="sending" :disabled="!consent" @click="handleValidateForm">
          {{ $vuetify.lang.t("$vuetify.main.patientReg.apply") }}
        </v-btn>
      </div>
    </v-card>
  </v-col>
</template>

<script>
const stepOne = () =>
  import("@/components/registration/registrationSteps/patient/stepOne");
import Terms from "@/components/UI/personalTerms/terms";
import PersonalData from "@/components/UI/personalTerms/personalData";
import Vue from "vue";
import { getAttribution } from "@/utils/attribution";

export default {
  components: {
    stepOne,
    Terms,
    PersonalData,
  },
  name: "userRegForm",
  data() {
    return {
      sending: false,
      consent: false,
    };
  },
  created() {
    this.$eventHub.$on("switch-patient-registration-tab", this.switchTab);
  },
  beforeDestroy() {
    this.$eventHub.$off("switch-patient-registration-tab", this.switchTab);
  },
  methods: {
    // step one validated the form and asks for the next step: register right away
    switchTab(value) {
      if (value === 2) this.patientRegistration();
    },
    handleValidateForm() {
      this.$eventHub.$emit("patient-step-one-form_validate-form");
    },
    patientRegistration() {
      let loginProvider = this.$store.getters['user/getLoginProvider'];

      let phone = this.$store.getters["user/getUserPhone"];
      let phone_country_code = this.$store.getters["user/getUserPhoneCountryCode"];

      if(loginProvider.provider_id) {
        phone = this.$store.getters["user/getUserUnverifiedPhone"];
        phone_country_code = this.$store.getters["user/getUserUnverifiedPhoneCountryCode"];
      }
      
      let payload = {
        locale: this.$store.getters["app/getSelectedLocale"],
        login_provider: loginProvider.provider ? loginProvider.provider : "",
        login_provider_id: loginProvider.provider_id ? loginProvider.provider_id : "",
        login_token: loginProvider.token ? loginProvider.token : "",
        phone: phone,
        phone_country_code: phone_country_code,
        email: this.$store.getters["user/getUserEmail"],
        // consent to the personal data processing and where the client came from (the site's cookie after its consent)
        consent: this.consent,
        attribution: getAttribution(),
        questionnaire: {
          name: this.$store.getters["user/getPatientQuestionnaire"]
            .questionnaire.name,
          age: this.$store.getters["user/getPatientQuestionnaire"].questionnaire
            .age,
          timezone: this.$store.getters["user/getUser"].timezone,
        },
      };
      this.sending = true;
      this.$store
        .dispatch("user/patientRegistration", payload)
        .then((response) => {
          Vue.swal({
            target: document.getElementById("main"),
            text: response.data.message,
            icon: "success",
            timer: 4000,
            toast: true,
            position: "top-right",
            showConfirmButton: false,
          });
          if (response.status === 200) {
            this.$store.dispatch('user/setChosenCalendarId', null)
            this.$store.dispatch('user/setChosenPsychologistId', null)

            this.$router.push("/dashboard/settings");
          }
        })
        .catch(() => {})
        .finally(() => {
          this.sending = false;
        });
    },
  },
};
</script>

<style scoped>
.patient-reg__title {
  padding: 24px 16px 0;
  color: #00A3B7;
  font-size: 25px;
  font-weight: 500;
  text-align: center;
}
.patient-reg__terms {
  padding: 0 16px;
  color: #575756;
  font-size: 14px;
}
</style>
